import {useEffect, useState} from "react";
import {useApi} from "@/lib/hook";
import {Select} from "@/theme";

export const PermissionsSelect = ({onInitHandler, userPermissions = [], userRoles, ...rest}) => {
    const [options, setOptions] = useState([])

    const {data: permission} = useApi({
        route: {name: 'authorization.permissions'},
        setting: {
            select: (resp) => resp.data,
            staleTime: Infinity,
        }
    })

    const {data: roles} = useApi({
        route: {name: 'authorization.roles'},
        data: {
            include: 'permissions',
        },
        setting: {
            select: (resp) => resp.data,
            staleTime: Infinity,
        }
    })

    useEffect(()=>{
        if (userPermissions && permission && userRoles?.length && roles){
            const rolePermissions = roles.find((item)=>userRoles.includes(item.name))?.permissions

            if (rolePermissions){

                setOptions(permission.filter((permissions)=>!rolePermissions.find((item)=>item.name === permissions.name)))
                const newPermissions = userPermissions.filter((permissions)=>!rolePermissions.find((item)=>item.name === permissions))

                if (!rest.value && onInitHandler){
                    onInitHandler(newPermissions)
                }
            }
        }

        if (!userRoles?.length){
            setOptions(permission)
        }
    }, [roles, permission, userRoles])

    return (
        <>
            <Select
                mode={'multiple'}
                fieldNames={{value: 'name', label: 'title'}}
                options={options}
                {...rest}
            />
        </>
    )
}